import { defineMessages } from '@jutro/locale';

export default defineMessages({
    primaryPhoneAlertMsg: {
        id: 'ml.gateway.views.account-landing.contacts.One phone must be a primary',
        defaultMessage: 'One phone must be a primary'
    },
    invalidEmail:{
        id:'ml.gateway.views.account-landing.contacts.invalidEmail',
        defaultMessage:"Email validation services are delayed, please verify the email entered is correct, and then proceed"
    }
})